const API = process.env.REACT_APP_BACKEND_URL;
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// Public page data. A 404/410 is "this page doesn't exist" (noindex holding page is correct); anything else — timeout,
// 5xx, blocked fetch while Googlebot renders — is retried, then reported as `error` so pages can fall back WITHOUT noindex.
export async function getPublic(path, { retries = 2, credentials } = {}) {
  for (let i = 0; ; i++) {
    try {
      const r = await fetch(`${API}/api/public${path}`, credentials ? { credentials } : undefined);
      if (r.ok) return { data: await r.json(), notFound: false, error: false };
      if (r.status === 404 || r.status === 410) return { data: null, notFound: true, error: false };
      if (i >= retries) return { data: null, notFound: false, error: true, status: r.status };
    } catch (e) {
      if (i >= retries) return { data: null, notFound: false, error: true, status: 0 };
    }
    await wait(400 * (i + 1));
  }
}
